import { Tag } from "primereact/tag";
import { getStatusBox } from "./box";
import { formatDateUTC } from "./user";
export const getStatus = (status) => {
    switch (status) {
        case 15:
            return {
                variant: 'success',
                text: "accepted"
            };
            break;
        case 2:
            return {
                variant: '',
                text: "expectConfirm"
            };
            break;
        case 3:
        case 16:
            return {
                variant: 'info',
                text: "in_way"
            };;
            break;
        case 18:
            return {
                variant: 'success',
                text: "atSclad"
            };;
            break;
        case 4:
            return {
                variant: 'success',
                text: "cameWarehouse"
            };

        case 22:
            return {
                variant: 'success',
                text: "На складе (КР)"
            };
        case 23:
            return {
                variant: 'info',
                text: "cameWarehouse"
            };

        case 24:
            return {
                variant: 'success',
                text: "RFdelivery"
            };

        case 25:
            return {
                variant: 'warning',
                text: "inProcess"
            };
        case 29:
            return {
                variant: 'info',
                text: "На ПВЗ"
            };
        case 30:
            return {
                variant: 'success',
                text: "Выдано"
            };
        case 31:
            return {
                variant: 'info',
                text: "На доставке"
            };
        default:
            return {
                variant: 'warning',
                text: "panding"
            };
    }
};

export const partialColumn = [
    {
        attr: "guid",
        labelKey: "guid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "codeid",
        labelKey: "codeid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "warehouse",
        labelKey: "warehouse",
        type: 3,
        opt: 7,
        optionLabel: "warehouse",
        hidden: true,
        editor: false
    },
    {
        attr: "warehouse_name",
        labelKey: "warehouse_name",
        hidden: false,
        editor: false
    },
    {
        attr: "send_date",
        label: "Дата отправики",
        hidden: false,
        editor: false,
        body: (rowData) => {
            return formatDateUTC(rowData.send_date);
        }
    },
    {
        attr: "accept_date",
        label: "Дата прихода",
        hidden: false,
        editor: false,
        body: (rowData) => {
            return rowData.accept_date ? formatDateUTC(rowData.accept_date) : "";
        }
    },
    {
        attr: "date_created",
        label: "Дата создания",
        hidden: false,
        editor: false,
        body: (rowData) => {
            return rowData.date_created ? formatDateUTC(rowData.date_created) : "";
        }
    },
    {
        attr: "partial_name",
        labelKey: "partial_name",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "destination",
        labelKey: "destination",
        type: 3,
        opt: 7,
        optionLabel: "warehouse",
        hidden: true,
        editor: false
    },
    {
        attr: "partial_code",
        labelKey: "partial_code",
        type: 1,
        opt: 7,
        optionLabel: "warehouse",
        hidden: false,
        editor: false
    },
    {
        attr: "destination_name",
        labelKey: "destination_name",
        type: 3,
        opt: 7,
        optionLabel: "warehouse",
        hidden: true,
        editor: false
    },
    {
        attr: "status",
        labelKey: "status",
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            return <Tag value={trans(getStatusBox(rowData.status).text)} severity={getStatusBox(rowData.status).variant} />;
        }
    },
    {
        attr: "boxCount",
        labelKey: "boxCount",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "height",
        labelKey: "height",
        type: 2,
        hidden: true,
        editor: false
    },
    {
        attr: "width",
        labelKey: "width",
        type: 2,
        hidden: true,
        editor: false
    },
    {
        attr: "length",
        labelKey: "length",
        type: 2,
        hidden: true,
        editor: false
    },
    {
        attr: "v_weight",
        labelKey: "v_weight",
        type: 2,
        hidden: true,
        editor: false,
        body: (item) => {
            return Number(parseFloat(item.v_weight) || 0).toFixed(2) ?? ''
        }
    },
    {
        attr: "gross_weight",
        labelKey: "gross_weight",
        type: 2,
        hidden: false,
        editor: false,
        body: (item) => {
            return Number(parseFloat(item.gross_weight) || 0).toFixed(2) ?? ''
        }
    }
]

export const partialBoxColumn = [
    {
        attr: "guid",
        label: "Text",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "codeid",
        label: "ID",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "tracking_code",
        label: "box_code",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "destination_name",
        label: "warehouse",
        // type: 3,
        // opt: 7,
        // optionLabel: "warehouse",
        hidden: false,
        editor: false
    },

    {
        attr: "date_created",
        label: "date_create",
        hidden: false,
        editor: false,
        body: (rowData) => {
            return formatDateUTC(rowData.date_created);
        }
    },
    ,
    {
        attr: "width",
        label: "width",
        type: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "height",
        label: "height",
        type: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "length",
        label: "length",
        type: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "v_weight",
        label: "volumetricWeight",
        type: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "gross_weight",
        label: "gross_weight",
        type: 2,
        hidden: false,
        editor: true
    },
]

